// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ReturpolitikRouteImport } from './routes/returpolitik'
import { Route as PrivatlivspolitikRouteImport } from './routes/privatlivspolitik'
import { Route as HandelsbetingelserRouteImport } from './routes/handelsbetingelser'
import { Route as CookiepolitikRouteImport } from './routes/cookiepolitik'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'

const ReturpolitikRoute = ReturpolitikRouteImport.update({
            id: '/returpolitik',path: '/returpolitik',getParentRoute: () => rootRouteImport
          })
const PrivatlivspolitikRoute = PrivatlivspolitikRouteImport.update({
            id: '/privatlivspolitik',path: '/privatlivspolitik',getParentRoute: () => rootRouteImport
          })
const HandelsbetingelserRoute = HandelsbetingelserRouteImport.update({
            id: '/handelsbetingelser',path: '/handelsbetingelser',getParentRoute: () => rootRouteImport
          })
const CookiepolitikRoute = CookiepolitikRouteImport.update({
            id: '/cookiepolitik',path: '/cookiepolitik',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,CookiepolitikRoute: CookiepolitikRoute,HandelsbetingelserRoute: HandelsbetingelserRoute,PrivatlivspolitikRoute: PrivatlivspolitikRoute,ReturpolitikRoute: ReturpolitikRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)